import entryService from '../../services/entryService'

const state = {
    entry: []
}
const initialState = {
    entry: []    
}


const getters = {
    entry: state => {
        return state.entry
    }
}

const actions = {
    getEntry({ commit}, id) {
        return new Promise((resolve,reject)=>{
            entryService.fetchEntry(id).then((entry) => {
            commit('setEntry', entry)
            resolve(entry)
        }).catch((error) => { //
            console.log( "error" +JSON.stringify(error.response.data))//
            reject(error)//
      })//
        })
    },
    
    getSingleEntry({commit}, params){
        return new Promise((resolve,reject)=>{
            entryService.fetchSingleEntry(params.id).then((entry) => {
            commit('setEntry', entry)
            resolve(entry)
        }).catch((error) => { //
            console.log( "error" +JSON.stringify(error.response.data))//
            reject(error)//
      })//
        })
        
        
    },
    editEntry({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putEntry(entry[1],entry[0])        
                .then((entry) => {
                    commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postEntry({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postEntry(entry)        
                .then((response) => {
                    commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    
    editBadanie({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putBadanie(entry[1],entry[0])        
                .then((entry) => {
                    // commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postBadanie({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postBadanie(entry)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    deleteBadanie({commit}, id){
        return new Promise((resolve, reject)=>{
            entryService.deleteBadanie(id)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    editPunkt({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putPunkt(entry[1],entry[0])        
                .then((entry) => {
                    // commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postPunkt({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postPunkt(entry)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    deletePunkt({commit}, id){
        return new Promise((resolve, reject)=>{
            entryService.deletePunkt(id)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    editParametr({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putParametr(entry[1],entry[0])        
                .then((entry) => {
                    // commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postParametr({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postParametr(entry)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    deleteParametr({commit}, id){
        return new Promise((resolve, reject)=>{
            entryService.deleteParametr(id)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    //substancja
    editSubstancja({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putSubstancja(entry[1],entry[0])        
                .then((entry) => {
                    // commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postSubstancja({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postSubstancja(entry)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    deleteSubstancja({commit}, id){
        return new Promise((resolve, reject)=>{
            entryService.deleteSubstancja(id)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    //instytucja
    editInstytucja({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putInstytucja(entry[1],entry[0])        
                .then((entry) => {
                    // commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postInstytucja({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postInstytucja(entry)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    deleteInstytucja({commit}, id){
        return new Promise((resolve, reject)=>{
            entryService.deleteInstytucja(id)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    //wytyczna
    editWytyczna({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.putWytyczna(entry[1],entry[0])        
                .then((entry) => {
                    // commit('editEntry', entry)
                    resolve(entry)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
      
    },
    postWytyczna({commit}, entry){
        return new Promise((resolve, reject)=>{
            entryService.postWytyczna(entry)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    deleteWytyczna({commit}, id){
        return new Promise((resolve, reject)=>{
            entryService.deleteWytyczna(id)        
                .then((response) => {
                    // commit('postEntry', response)
                    resolve(response)
                })
                .catch((error) => {
                    console.log( "error" +JSON.stringify(error.response.data))
                    reject(error)
                })
        })
    },
    RESET_MODULE({commit}){
        commit("setEntry", initialState.entry)
    },
}
    


const mutations = {
    setEntry (state, entry) {
        state.entry = entry
    },
    editEntry (state, entry, id) {
        // let record = state.entry.findIndex(element => {return element.id == entry.id})
        // state.entry[record] = entry
        // console.log("edytowano wpis" + JSON.stringify(state.entry[record]))
    },
    RESET_MODULE (state) { // To reset the entire module
        Object.assign(state, initialState)
       },
    postEntry(state,response){

       }
    
}

export default {
    namespaced:true,
    state,
    getters,
    actions,
    mutations
}